/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Outlook_Humanize_Tone_NaturalInputs */



/**
* | output |
* | --- |
* | "Natural" |
*
* @param {Chat_Outlook_Humanize_Tone_NaturalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_outlook_humanize_tone_natural = /** @type {((inputs?: Chat_Outlook_Humanize_Tone_NaturalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Outlook_Humanize_Tone_NaturalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Natürlich")
	return /** @type {LocalizedString} */ ("Natural")
});